module.exports = __webpack_public_path__ + "static/neuro-room-mobile-8fc2d5b130d87d68dde11c650dcf55f0.jpg";